module.exports = __webpack_public_path__ + "static/media/BOTON WEB_Canto RO.f7b3d6d8.png";